<template>
<div>
    <b-navbar toggleable="lg" type="dark" variant="light">
        <b-navbar-brand href="#" class="text-dark">
            <strong>General Settings</strong>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    </b-navbar>
    <b-container fluid>
        <b-row class="mt-3" >

            <b-col cols="12" style="height:calc(100vh - 200px);overflow-y:auto;">
                <b-card header-tag="header">
                    <template v-slot:header>
                        <h6 class="mb-0">Companies</h6>
                    </template>
                    <b-row>
                         <b-col cols="12">
                          <b-card header-tag="header">
                              <template v-slot:header>
                                  <h6 class="mb-0">Global</h6>
                              </template>
                              <b-row>
                                <b-col cols="6">
                                  <h3>Exact Name Match</h3>
                                    <b-table-simple class="table my-2">
                                  <b-thead>
                                      <b-tr>
                                          <b-th scope="col">Risk</b-th>
                                          <b-th scope="col">From</b-th>
                                          <b-th scope="col">To</b-th>
                                      </b-tr>
                                  </b-thead>

                                  <b-tbody>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="success">Very Rare</b-badge>
                                          </b-td>
                                          <b-td>1</b-td>
                                          <b-td>
                                              <b-input v-model="veryRareLimit" onkeydown="return event.keyCode !== 69" type="number" max="30"></b-input>
                                          </b-td>
                                      </b-tr>

                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="warning">Rare</b-badge>
                                          </b-td>
                                          <b-td>{{veryRareLimit ? parseInt(veryRareLimit)+1 : 0}}</b-td>
                                          <b-td>
                                              <b-input onkeydown="return event.keyCode !== 69" v-model="rareLimit" type="number" min="31" max="75"></b-input>
                                          </b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="danger">Common</b-badge>
                                          </b-td>
                                          <b-td>{{rareLimit ? parseInt(rareLimit)+1 : 0}}</b-td>
                                          <b-td>
                                              <b-input onkeydown="return event.keyCode !== 69" v-model="commonLimit" type="number" min="31" max="75"></b-input>
                                          </b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="primery">Very Common</b-badge>
                                          </b-td>
                                          <b-td>{{commonLimit ? parseInt(commonLimit)+1 : 0}}</b-td>
                                          <b-td>100</b-td>
                                      </b-tr>
                                  </b-tbody>
                              </b-table-simple>
                                </b-col>
                                <b-col cols="6">
                                  <h3>Partial Name Match</h3>
                                  <b-table-simple class="table my-2">
                                  <b-thead>
                                      <b-tr>
                                          <b-th scope="col">Risk</b-th>
                                          <b-th scope="col">From</b-th>
                                          <b-th scope="col">To</b-th>
                                      </b-tr>
                                  </b-thead>

                                  <b-tbody>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="success">Very Rare</b-badge>
                                          </b-td>
                                          <b-td>1</b-td>
                                          <b-td>
                                              <b-input v-model="veryRareLimit" onkeydown="return event.keyCode !== 69" type="number" max="30"></b-input>
                                          </b-td>
                                      </b-tr>

                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="warning">Rare</b-badge>
                                          </b-td>
                                          <b-td>{{veryRareLimit ? parseInt(veryRareLimit)+1 : 0}}</b-td>
                                          <b-td>
                                              <b-input onkeydown="return event.keyCode !== 69" v-model="rareLimit" type="number" min="31" max="75"></b-input>
                                          </b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="danger">Common</b-badge>
                                          </b-td>
                                          <b-td>{{rareLimit ? parseInt(rareLimit)+1 : 0}}</b-td>
                                          <b-td>
                                              <b-input onkeydown="return event.keyCode !== 69" v-model="commonLimit" type="number" min="31" max="75"></b-input>
                                          </b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="primery">Very Common</b-badge>
                                          </b-td>
                                          <b-td>{{commonLimit ? parseInt(commonLimit)+1 : 0}}</b-td>
                                          <b-td>100</b-td>
                                      </b-tr>
                                  </b-tbody>
                              </b-table-simple>

                                </b-col>
                              </b-row>
                              
                          </b-card>
                        </b-col>
                        
                    </b-row>
                     <b-row class="mt-3">
                         <b-col cols="12">
                          <b-card header-tag="header">
                              <template v-slot:header>
                                  <h6 class="mb-0">Country</h6>
                              </template>
                              <b-row>
                                <b-col cols="6">
                                  <h3>Exact Name Match</h3>
                                    <b-table-simple class="table my-2">
                                  <b-thead>
                                      <b-tr>
                                          <b-th scope="col">Risk</b-th>
                                          <b-th scope="col">From</b-th>
                                          <b-th scope="col">To</b-th>
                                      </b-tr>
                                  </b-thead>

                                  <b-tbody>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="success">Very Rare</b-badge>
                                          </b-td>
                                          <b-td>1</b-td>
                                          <b-td>
                                              <b-input v-model="veryRareLimit" onkeydown="return event.keyCode !== 69" type="number" max="30"></b-input>
                                          </b-td>
                                      </b-tr>

                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="warning">Rare</b-badge>
                                          </b-td>
                                          <b-td>{{veryRareLimit ? parseInt(veryRareLimit)+1 : 0}}</b-td>
                                          <b-td>
                                              <b-input onkeydown="return event.keyCode !== 69" v-model="rareLimit" type="number" min="31" max="75"></b-input>
                                          </b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="danger">Common</b-badge>
                                          </b-td>
                                          <b-td>{{rareLimit ? parseInt(rareLimit)+1 : 0}}</b-td>
                                          <b-td>
                                              <b-input onkeydown="return event.keyCode !== 69" v-model="commonLimit" type="number" min="31" max="75"></b-input>
                                          </b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="primery">Very Common</b-badge>
                                          </b-td>
                                          <b-td>{{commonLimit ? parseInt(commonLimit)+1 : 0}}</b-td>
                                          <b-td>100</b-td>
                                      </b-tr>
                                  </b-tbody>
                              </b-table-simple>
                                </b-col>
                                <b-col cols="6">
                                  <h3>Partial Name Match</h3>
                                  <b-table-simple class="table my-2">
                                  <b-thead>
                                      <b-tr>
                                          <b-th scope="col">Risk</b-th>
                                          <b-th scope="col">From</b-th>
                                          <b-th scope="col">To</b-th>
                                      </b-tr>
                                  </b-thead>

                                  <b-tbody>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="success">Very Rare</b-badge>
                                          </b-td>
                                          <b-td>1</b-td>
                                          <b-td>
                                              <b-input v-model="veryRareLimit" onkeydown="return event.keyCode !== 69" type="number" max="30"></b-input>
                                          </b-td>
                                      </b-tr>

                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="warning">Rare</b-badge>
                                          </b-td>
                                          <b-td>{{veryRareLimit ? parseInt(veryRareLimit)+1 : 0}}</b-td>
                                          <b-td>
                                              <b-input onkeydown="return event.keyCode !== 69" v-model="rareLimit" type="number" min="31" max="75"></b-input>
                                          </b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="danger">Common</b-badge>
                                          </b-td>
                                          <b-td>{{rareLimit ? parseInt(rareLimit)+1 : 0}}</b-td>
                                          <b-td>
                                              <b-input onkeydown="return event.keyCode !== 69" v-model="commonLimit" type="number" min="31" max="75"></b-input>
                                          </b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>
                                              <b-badge variant="primery">Very Common</b-badge>
                                          </b-td>
                                          <b-td>{{commonLimit ? parseInt(commonLimit)+1 : 0}}</b-td>
                                          <b-td>100</b-td>
                                      </b-tr>
                                  </b-tbody>
                              </b-table-simple>

                                </b-col>
                              </b-row>
                              
                          </b-card>
                        </b-col>
                        
                    </b-row>
                   

                    

                </b-card>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
export default {
    name: "PriSettingsGeneralPage",
    data() {
        return {
            veryRareLimit: 25,
            rareLimit: 50,
            commonLimit: 75,
            veryCommonLimit: 1
        };
    }
};
</script>
